// extracted by mini-css-extract-plugin
module.exports = {"listHeader":"_2Ozfv51a","pagination":"_1pltpXX2","lists":"_374g0uQ4","noList":"pEpgeuR5","truncateListName":"_1s4pXvAf"};